import React from 'react';
import { PriceDisplay } from '@heartinternet/hi-ui';
import { Button } from '@heartinternet/hi-ui';
import { Text } from '@heartinternet/hi-ui';
import { Icon } from '@heartinternet/hi-ui';
import { List } from '@heartinternet/hi-ui';
import { ListItem } from '@heartinternet/hi-ui';
import { Form } from '@heartinternet/hi-ui';
import type { Product } from '../types';

interface SimpleProductCardProps {
  product: Product;
  formAction: string;
  isReseller?: boolean;
}

export const SimpleProductCard: React.FC<SimpleProductCardProps> = ({
  product,
  formAction,
  isReseller,
}) => {
  const price = product.price
    ? isReseller && product.price.resellerAmount != null
      ? product.price.resellerAmount
      : product.price.amount
    : undefined;

  const priceDisplay =
    product.price && price != null ? (
      <PriceDisplay
        amount={price}
        currency={product.price.currency}
        interval={product.price.interval}
        intervalFormat="long"
        size="lg"
      />
    ) : null;

  return (
    <div className="hi-ui-extras-page__product-content">
      <Text variant="body" inline>
        {product.description}
      </Text>
      <div className="hi-ui-extras-page__specs-grid">
        <div className="hi-ui-extras-page__specs-card">
          <List className="hi-ui-extras-page__features hi-ui-extras-page__features--icons">
            {product.features.map((text, i) => (
              <ListItem key={i}>
                <Icon name="check-circle-grey" size={18} />
                {text}
              </ListItem>
            ))}
          </List>
        </div>
      </div>
      {product.ctaHref ? (
        <div className="hi-ui-extras-page__card-footer">
          {priceDisplay}
          <Button as="a" href={product.ctaHref} variant="primary">
            {product.ctaText || 'View'}
          </Button>
        </div>
      ) : (
        <Form action={formAction} method="post">
          <input type="hidden" name="type" value="MULTI" />
          <input type="hidden" name="submit-type" value="PURCHASE" />
          <input type="hidden" name="basket-add-code" value={product.basketAddCode} />
          <div className="hi-ui-extras-page__card-footer">
            {priceDisplay}
            <Button type="submit" variant="primary">
              {product.ctaText || 'Add to basket'}
            </Button>
          </div>
        </Form>
      )}
    </div>
  );
};
